import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import MetricCard from './MetricCard';

const SecondaryContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '20px',
  marginBottom: '28px',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gap: '12px'
  }
}));

const SecondaryMetrics = ({ performanceMetrics }) => {
  return (
    <SecondaryContainer>
      <MetricCard
        title="Organic Clicks This Month"
        value={performanceMetrics.organicClicks}
        change={performanceMetrics.organicClicksChange}
      />
      
      <MetricCard
        title="Avg. Google Search Volume"
        value={performanceMetrics.avgSearchVolume}
        change={performanceMetrics.avgSearchVolumeChange}
      />
    </SecondaryContainer>
  );
};

export default SecondaryMetrics;